(function () {
  function updateImgAltText() {
    if (typeof imgALt === "undefined") {
      return;
    }

    const imgElements = document.querySelectorAll("img");

    imgElements.forEach((img) => {
      const imgDataAlt = img.getAttribute("data-alt") || null;
      if (!imgDataAlt) {
        var imgHref =
          img.getAttribute("data-src") || img.getAttribute("src") || "";
        if (imgHref && imgHref.includes("https://images.secretlab.co/")) {
          var hasTR = imgHref?.includes("tr:");
          if (hasTR) {
            var imgHrefArray = imgHref?.split("/");
            if (imgHrefArray) {
              imgHref = imgHref?.replace(
                `/${imgHrefArray[imgHrefArray?.length - 2]}`,
                ""
              );
            }
          }
          const imgAltData = imgALt[imgHref]?.replace(/"/g, '\'');
          if (imgAltData) {
            img.setAttribute("alt", imgAltData);
          }
        }
      }
    });
  }

  updateImgAltText();
})();
